<template>
  <div class="alert-box">
    <v-alert
      v-for="notification in notifications"
      :key="notification.code"
      :type="notification.type"
      :value="notification.visible"
      :dismissible="notification.dismissible"
      @input="notificationDismissed(notification)"
      transition="slide-y-transition"
      >{{ notification.message }}</v-alert
    >
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { StoredNotification } from "@/notification/notification-store";
import { StoreGetter } from "@/store/storeGetter.decorator";

@Component
export default class Notifications extends Vue {
  @StoreGetter("notification/notifications")
  notifications!: StoredNotification[];
  notificationDismissed(notification: StoredNotification) {
    notification.outdated = true;
    this.$notification.clean();
  }
}
</script>

<style lang="scss">
.alert-box {
  position: fixed !important;
  top: 5em;
  right: 1em;
  z-index: 999;
}
</style>
